package com.havn.app.core.settings

import kotlinx.browser.window
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val HavnUnitPreferencesKey = "havn.unitPreferences"
private val HavnUnitJson = Json { ignoreUnknownKeys = true }

actual fun loadStoredHavnUnitPreferences(): HavnUnitPreferences {
    val raw = window.localStorage.getItem(HavnUnitPreferencesKey) ?: return HavnUnitPreferences()
    return runCatching {
        val stored = HavnUnitPreferencesStorageDto.serializer().let { serializer ->
            HavnUnitJson.decodeFromString(serializer, raw)
        }
        HavnUnitPreferences(
            measurementSystem = HavnMeasurementSystem.fromCode(stored.measurementSystem),
            currency = HavnCurrency.fromCode(stored.currency)
        )
    }.getOrDefault(HavnUnitPreferences())
}

actual fun storeHavnUnitPreferences(preferences: HavnUnitPreferences) {
    val stored = HavnUnitPreferencesStorageDto(
        measurementSystem = preferences.measurementSystem.code,
        currency = preferences.currency.code
    )
    window.localStorage.setItem(HavnUnitPreferencesKey, HavnUnitJson.encodeToString(stored))
}

@Serializable
private data class HavnUnitPreferencesStorageDto(
    val measurementSystem: String,
    val currency: String
)
